import amplitude from 'utils/amplitude';
import { EnumAFEvents, EnumEvents } from 'constants/enums';
import { PaymentTypes } from 'Modules/Checkout/types';
import { FbqEventsEnum, fbqTrack } from 'utils/fbq';
import { TagManagerGoToCheckoutFinishPage } from 'utils/tagManager';
import { IShop } from 'Modules/Shops/types';
import analyticsManager from '../tagManager/manager';
import { EnumYaCountersGlobus, ymReachGoalGlobus } from 'lib/yandexMetrics';
import { ICheckoutOrder } from './types';

export default function checkoutSuccessAnalytic(
  order: ICheckoutOrder,
  shop: IShop,
  asap: boolean,
  paymentType: PaymentTypes
): void {
  const { id, products, total_price, fewer_plastic_bags } = order;
  const { id: shopId, group_en, group } = shop;
  TagManagerGoToCheckoutFinishPage(id, products);

  analyticsManager.af(EnumAFEvents.AF_PURCHASE, {
    af_order_id: String(id),
    af_price: total_price,
  });

  order.first_order &&
    analyticsManager.af(EnumAFEvents.AF_FIRST_PURCHASE, {
      af_order_id: String(id),
      af_price: total_price,
    });

  amplitude.logEvent(EnumEvents.CHECKOUT_COMPLETE, {
    'order id': id,
    'shop id': shopId,
    'shop group': group_en || group,
    'order size': products.length,
    'fewer packages': Boolean(fewer_plastic_bags),
    price: total_price,
    asap: asap,
    type: paymentType,
  });

  fbqTrack(FbqEventsEnum.Purchase, {
    value: total_price,
    currency: 'RUB',
  });

  ymReachGoalGlobus(EnumYaCountersGlobus.checkout_complete);
}
